<template>
  <div class="education">
    <topNav></topNav>
    <div class="top">
      <el-carousel trigger="click" class="bannerMain1" v-show="banners1.length>1">
        <el-carousel-item v-for="(item,index) in banners1" :key="index">
          <div class="bannerimg1">
            <img :src="item" class="bannerimg1" alt="" />
            <!-- <a v-if="index == 0" href="https://www.dexunzhenggu.cn/h5/html/showimg.html?id=1" target="_blank"></a> -->
            <!-- <img :src="item.imgSrc" class="bannerimg" alt="" />
            <a v-if="item.to" :href="item.url" target="_blank"></a> -->
          </div>
        </el-carousel-item>
      </el-carousel>
      <img :src="banners1[0]" v-show="banners1.length<=1" class="bannerimg1" alt="" />
    </div>
    <div class="teacher">
      <!-- <div class="title">
        <div class="title-t">
          <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
          <span>交易师名师团队</span>
          <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
        </div>
        <div class="title-b">投顾团队坐镇，大湾区炒股好帮手</div>
      </div> -->
      <div class="hexing">
        <!-- <span class="xlk" @click="wenzi(0)">核心优势</span>
          <span class="" @click="wenzi(1)">产品亮点</span> -->
        <span
          :class="{ xlk: linkIndex == item.name ? true : false }"
          v-for="(item, index) in investList"
          :key="index"
          @click="wenzi(item)"
          >{{ item.name }}</span
        >
      </div>
      <div class="BoxDiv">
        <div class="demobox bigNav" style="margin-bottom:60px;">
          <el-carousel trigger="click" class="bannerMain" :interval="10000" v-show="banners.length>1">
            <el-carousel-item v-for="(item, index) in banners" :key="index">
              <div class="bannerimg">
                <img :src="item" class="bannerimg" alt="" />
              </div>
            </el-carousel-item>
          </el-carousel>
          <img :src="banners[0]" v-show="banners.length<=1" class="bannerimg" alt="" />
        </div>
        <div
          class="laoshiBox"
          v-for="item in laoshiList"
          :key="item.in_edu_teacher.id"
        >
          <div class="laoshi">
            <!--  item.InEduTeacher.pictures-->
            <img :src="item.in_edu_teacher.pictures" alt="" />
            <div class="into" @click="jinRU(item, 1)"></div>
          </div>
          <div class="vedioLisi">
            <div
              class="vedioCard"
              v-for="item2 in item.videos"
              :key="item2.id"
              @click="jinRU(item2, 2)"
            >
              <div class="img">
                <img :src="item2.img" alt="" />
                <div class="zhezhao"></div>
                <div class="sanjiao"></div>
              </div>
              <span class="font1">{{ item2.title }}</span>
              <span class="font2">发布 {{ item2.published }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="hexinyoushi">
        <img src="@/common/images/education/26920.png" alt="">
      </div>
      <!-- 封面 -->
      <!-- <img
        src="@/common/images/productCenter/A1/btnl.png"
        class="btn btnl"
        id="btnl"
        alt=""
        @click="pref"
        v-if="TeacherList.length > 2"
      />
      <img
        src="@/common/images/productCenter/A1/btnr.png"
        class="btn btnr"
        id="btnr"
        alt=""
        @click="nextf"
        v-if="TeacherList.length > 2"
      />
      <div class="teacherCard">
        <div
          class="teacherCard_"
          v-if="TeacherList.length > 2"
          :style="{ left: left * -468 + 'px' }"
        >
          <div
            class="cardItem"
            v-for="(item, index) in TeacherList"
            :key="'k' + index"
          >
            <img class="card" :src="item.img" alt="" />
            <div class="into" @click="toTeacher(item.id, index)"></div>
          </div>
        </div>
        <div class="_teacherCard" v-if="TeacherList.length <= 2">
          <div
            class="cardItem"
            v-for="(item, index) in TeacherList"
            :key="'k' + index"
          >
            <img class="card" :src="item.img" alt="" />
            <div class="into" @click="toTeacher(item.id, index)"></div>
          </div>
        </div> -->
      <!-- <div class="cardItem">
          <img class="card" :src="TeacherList[1].img" alt="" />
          <div class="into" @click="toTeacher(TeacherList[1].id, 1)"></div>
        </div> -->
      <!-- <div class="cardItem">
          <img class="card" :src="TeacherList[2].img" alt="" />
          <div class="into" @click="toTeacher(TeacherList[2].id, 2)"></div>
        </div> -->
      <!-- </div> -->
      <!-- <div class="cardBackground"></div> -->
    </div>
    <!-- <div class="subject">
      <div class="title" style="margin-top: 0px">
        <div class="title-t">
          <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
          <span>建党百年专题投教视频</span>
          <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
        </div>
        <div class="title-b">献礼100年党庆 金融实干报国</div>
      </div>
      <img class="subImg" :src="SubjectList[0].img" alt="" />
      <div class="into" @click="toSubject()"></div>
    </div> -->

    <Bottoms></Bottoms>
  </div>
</template>

<script>
import topNav from "./sub/topNav";
import Bottoms from "./sub/Bottoms";
import { l, TtoDay } from "@/utils/tool";
import { colunmList,productList,columnTypeList } from "@/api/topNav.js";
import {
  investEduList,
  ieTeacherList,
  videoList,
  ieTeacherList2,
} from "@/api/education.js";
export default {
  name: "education",
  components: { topNav, Bottoms },
  data() {
    return {
      banners1:[],
      TeacherList: [],
      SubjectList: [{ img: "", id: "" }],
      left: 0,
      mx: 0,
      investList: [],
      linkIndex: "",
      banners: [],
      laoshiList: [],
      needData: [],
      obj: {
        lanmuID: "", //财教专栏id
        laoshiID: "", //老师id
      },
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    // this.getTeacherList();
    // this.getSubjectList();
    var index = this.$route.query.index;
    if (index == 1) {
      window.scrollTo(0, 450);
    } else if (index == 2) {
      window.scrollTo(0, 1000);
    }
    this.selectf();
  },
  methods: {
    getTeacherList: function () {
      var cate_type = 1;
      this.$api.tjzx_list(cate_type).then((res) => {
        if (res.code == 0) {
          this.TeacherList = res.data.list;
          this.mx = this.TeacherList.length - 2;
          // console.log(this.TeacherList);
        } else {
          alert("获取失败");
        }
      });
    },
    getSubjectList: function () {
      var cate_type = 2;
      this.$api.tjzx_list(cate_type).then((res) => {
        if (res.code == 0) {
          this.SubjectList = res.data.list;
        } else {
          alert("获取失败");
        }
      });
    },

    toTeacher: function (id, i) {
      var teacher = this.TeacherList[i];
      var obj = JSON.stringify(teacher);
      localStorage.setItem("teacher", obj);

      this.$router.push({
        name: "teacherVideo",
        query: {
          id: id,
        },
      });
    },
    toSubject: function (id) {
      if (this.SubjectList != null) {
        var subject = this.SubjectList[0];
        var obj = JSON.stringify(subject);
        localStorage.setItem("subject", obj);
        this.$router.push({
          name: "subjectVideo",
          query: {
            id: this.SubjectList[0].id,
          },
        });
      }
    },
    pref: function () {
      if (this.left != 0) {
        this.left--;
      }
    },
    nextf: function () {
      console.log(this.left, this.mx);
      if (this.left != this.mx) {
        this.left++;
      }
    },
    wenzi(item) {
      //锚链接跳转

      this.linkIndex = item.name;
      // l(item);
      // ieTeacherList2({ invest_edu_id: item.id }).then((res) => {
      //   //老师加视频列表
      //   if (res.code == 200 && res.data.list) {
      //     // res.data.list.forEach((v) => {
      //     //   v.videos.forEach((v2) => {
      //     //     let published = new Date(v2.published).getTime();
      //     //     v2.published = TtoDay(published);
      //     //   });
      //     // });
      //     // this.laoshiList = res.data.list;
      //     l(res,'ls');
      //   }
      // });
      // this.beCurrent(item.id);
      investEduList({ status: 1,id: item.id }).then((res) => {
        //财教栏目列表
        if (res.code == 200) {
          // this.investList = res.data.list;
          // this.wenzi(res.data.list[0]);
          this.banners = res.data.list[0].pictures.split(",");
          // this.obj.lanmuID = res.data.list[0].id; //栏目id
          this.beCurrent(res.data.list[0].id);
          l(res,'财教栏目列表222');
        }
      });
      // let bannerID = document.getElementById(item.id);
      // if(bannerID) window.scroll(0,(bannerID.offsetTop-89));
      // l(item,bannerID);
      // let banner = document.getElementById('banner');
      // let banner2 = document.getElementById('banner2');
      // let items = document.querySelector('.hexing').children;
      // console.log(banner.offsetTop);
      // if(item==0){
      //     // banner.animate({scrolTop:100});
      //     // banner.scrollIntoView();
      //     // window.screenTop(0,10);
      //     window.scroll(0,(banner.offsetTop-89));
      //     items[0].classList.add('xlk');
      //     items[1].classList.remove('xlk');
      // }else{
      //    window.scroll(0,(banner2.offsetTop-89));
      //     items[1].classList.add('xlk');
      //     items[0].classList.remove('xlk');
      //     // document.getElementById('banner2').scrollIntoView();
      // }
    },
    jinRU(item, n) {
      //进入专栏
      if (n == 1) {
        sessionStorage.setItem('videosList','');
        this.$router.push({
          name: "teacherVideo",
          query: {
            id: item.in_edu_teacher.id,
          },
        });
      } else {
        sessionStorage.setItem('videosList',JSON.stringify(item));
        this.$router.push({
          name: "teacherVideo",
          query: {
            id: item.teacher_id,
          },
        });
      }
    },
    selectf() {
        colunmList({ column_name:'财教中心' }).then((res) => { //产品管理列表
        //列表
        if (res.code == 200 && res.data.list) {
          // l(res,'ds');
          this.banners1 = res.data.list[0].pictures.split(',');
        }
      });
      investEduList({ status: 1 }).then((res) => {
        //财教栏目列表
        if (res.code == 200) {
          this.investList = res.data.list;
          this.wenzi(res.data.list[0]);
          this.banners = res.data.list[0].pictures.split(",");
          this.obj.lanmuID = res.data.list[0].id; //栏目id
          this.beCurrent(res.data.list[0].id);
          // l(res,'财教栏目列表');
        }
      });
    },
    beCurrent(id) {
      ieTeacherList2({ invest_edu_id: id }).then((res) => {
        //老师加视频列表
        if (res.code == 200 && res.data.list) {
          // this.laoshiList = [];
          res.data.list.forEach((v) => {
            v.videos = v.videos.slice(0,8);
            v.videos.forEach((v2,index2) => {
              let published = new Date(v2.published).getTime();
              v2.published = TtoDay(published);
            });
          });

          this.laoshiList = res.data.list;
          
        }
      });
      // ieTeacherList({ status: 1, invest_edu_id: id }).then((res2) => {
      //   //财教老师列表
      //   if (res2.code == 200) {
      //     this.laoshiList = res2.data.list;
      //     // this.obj.laoshiID = res2.data.list[0].InEduTeacher.id; //老师id
      //     res2.data.list.forEach((v2) => {
      //       videoList({
      //         status: 1,
      //         teacher_id: v2.InEduTeacher.id,
      //       }).then((res3) => {
      //         //财教视频列表
      //         if (res3.code == 200) {
      //           this.needData = [];
      //           res3.data.list.forEach((v3, index) => {
      //             if (index < 8) {
      //               this.needData.push(v3);
      //             }
      //           });
      //         }
      //       });
      //     });
      //   }
      // });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.education{
  overflow: hidden;
}
.bannerMain >>> .el-carousel__container {
  width: 100%;
  height: 350px !important;
}
.bannerMain1 >>> .el-carousel__container {
  width: 100%;
  height: 496px !important;
}
.bannerimg1 {
  display: block;
  width: 100%;
  max-width: 1920px;
  height: 496px !important;
  margin: auto;
  position: relative;
}
.bannerimg {
  display: block;
  width: 100%;
  max-width: 1920px;
  height: 350px !important;
  position: relative;
}
.BoxDiv {
  width: 1430px;
  border-top: 1px solid #e1e1e1;
  margin: 8px auto;
  padding-top: 20px;
}
.top {
  width: 100%;
  /* height: 400px; */
  /* background: blue; */
  /* background: url("../common/images/education/education.png") no-repeat; */
  background-size: 100% 100%;
  opacity: 1;
}
.teacher {
  position: relative;
  /* padding-bottom: 60px; */
}
.title {
  width: 100%;
  margin-top: 60px;
}
.title-t {
  display: flex;
  justify-content: center;
  align-items: center;
}
.title-t span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}
.title-b {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  opacity: 0.8;
  margin: 0 auto;
  margin-top: 4px;
}
.teacherCard {
  width: 936px;
  height: 366px;
  margin: 0 auto;
  z-index: 9;
  overflow: hidden;
  position: relative;
}
.btn {
  display: block;
  position: absolute;
  cursor: pointer;
  top: 210px;
  left: 50%;
  z-index: 10;
}
.btnl {
  margin-left: -564px;
}
.btnr {
  margin-left: 518px;
}
.teacherCard_ {
  min-width: 10000px;
  height: 100%;
  position: absolute;
  z-index: 9;
  overflow: hidden;
  /* display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap; */
  left: 0;
  transition: all 0.5s;
}
._teacherCard {
  width: 100%;
  height: 100%;
  z-index: 9;
  overflow: hidden;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.cardItem {
  float: left;
  width: 452px;
  margin: 0 8px;
}
.card {
  width: 452px;
  height: 254px;
  background-color: #ccc;
  margin-top: 40px;
}
.into {
  width: 136px;
  height: 38px;
  /* margin: 30px auto 0; */
  background: url("../common/images/education/intoN.png") no-repeat;
  background-size: 100% 100%;
      margin: auto;
    margin-top: 41px;

  cursor: pointer;
}
.into:hover {
  background: url("../common/images/education/intoY.png") no-repeat;
  background-size: 100% 100%;
}
.cardBackground {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 317px;
  background: url("../common/images/education/cardBackground.png") no-repeat;
  background-size: 100% 100%;
}
/* 专题 */
.subject {
  box-sizing: border-box;
  width: 100%;
  height: 847px;
  background: url("../common/images/education/subject.png") no-repeat;
  background-size: 100% 100%;
  padding-top: 56px;
  margin-top: 0px;
}
.subImg {
  width: 980px;
  height: 551px;
  margin: 40px auto 0px;
}
.hexing {
  width: 100%;
  height: 74px;
  display: flex;
  justify-content: space-evenly;
  line-height: 80px;
}
.hexing span {
  font-family: PingFang SC-Regular;
  color: #333333;
  font-size: 26px;
  /* border-bottom: 1px solid #DE161E; */
  font-weight: 400;
  height: 65px;
  width: 160px;
  margin: 10px 0;
}
.hexing span:hover {
  cursor: pointer;
}
.xlk {
  border-bottom: 5px solid #de161e;
  padding-bottom: 4px;
  color: #de161e !important;
}
.vedioLisi {
  display: flex;
  flex-wrap: wrap;
  width: 950px;
  /* margin: 16px auto 0; */
}
.vedioLisi img {
  width: 210px;
  height: 110px;
}
.vedioCard {
  width: 210px;
  text-align: left;
  margin-right: 10px;
  /* margin-left: 10px; */
  cursor: pointer;
}
.vedioCard .img {
  position: relative;
  border: 2px solid #E7272B;
  width: 210px;
  height: 110px;
}
.zhezhao {
  position: absolute;
  top: 0;
  width: 210px;
  height: 110px;
  background-color: #1d1d1d;
  opacity: 0.8;
  z-index: 10;
  display: none;
}
.sanjiao {
  position: absolute;
  /* border-right: 15px solid transparent; */
  border-top: 18px solid transparent;
  border-left: 27px solid #fff;
  border-bottom: 18px solid transparent;
  width: 0;
  height: 0;
  opacity: 1;
  z-index: 11;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  display: none;
  border-radius: 4px;
}
.vedioCard:hover .zhezhao {
  display: block;
}
.vedioCard:hover .sanjiao {
  display: block;
}
.vedioLisi span {
  display: block;
  /* margin: 10px 0; */
}
.vedioLisi .font1 {
font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-top: 8px;
    height: 40px;
    /* white-space: nowrap; */
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.vedioLisi .font2 {
  font-size: 14px;
  margin-top: 10px;
  color: #999999;
  margin-top: 12px;
  margin-bottom: 10px;
}
.vedioCard:hover .font1 {
  color: #de161e !important;
  cursor: pointer;
  /* display: block; */
}
/* .vedioLisi .img:hover{
  color: #DE161E !important;
} */
.vedioCard2 {
  height: 25px;
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 25px;
  margin-top: 20px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vedioCard3 {
  height: 25px;
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #e7413b;
  line-height: 25px;
  margin-top: 16px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vedioCard4 {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
  margin-top: 10px;
  text-align: left;
}
.vedioCard5 {
  position: absolute;
  top: 6px;
  left: 6px;
  width: 290px;
  height: 152px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 6px 6px 6px 6px;
  font-weight: 400;
  font-family: PingFang SC-Regular, PingFang SC;
  font-size: 26px;
  color: #ffffff;
  line-height: 152px;
}
.laoshiBox {
  margin-top: 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  /* margin-bottom: 133px; */
}
.laoshi{
  margin-right: 20px;
}
.laoshi img {
  width: 530px;
  height: 298px;
}
.hexinyoushi{
  width: 1920px;
  margin: auto;
  height: 774px;
  margin-top: 60px;
}
.hexinyoushi img{
  width: 100%;
  height: 774px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/education.vue